<template>
    <div align="center" class="cssload-fond hide-element" id="loading-overlay">
        <div class="cssload-container-general">
            <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_1"> </div></div>
            <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_2"> </div></div>
            <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_3"> </div></div>
            <div class="cssload-internal"><div class="cssload-ballcolor cssload-ball_4"> </div></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                default: 'Loading...',
            },
        },
    };
</script>
